import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsInputsGroupModule } from '../formsInputsGroup';
import { FormsInputModule } from '../formsInput';

import { FormsPhoneInputComponent } from './forms-phone-input.shared.component';


@NgModule({
    declarations: [
        FormsPhoneInputComponent
    ],
    imports: [
        CommonModule,
        FormsInputsGroupModule,
        FormsInputModule,
    ],
    exports: [
        FormsPhoneInputComponent
    ],
    providers: [],
})
export class FormsPhoneInputModule { }
